export default [
    {
        path: 'relatorio-quantitativo-exame-solicitado',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-relatorio-quantitativo-exame-solicitado' */
            '@/views/exame-laboratorial/relatorio-quantitativo-exame-solicitado/Index'
        ),
        redirect: 'relatorio-quantitativo-exame-solicitado/index',
        children: [
            {
                name: 'exame-laboratorial-relatorio-quantitativo-exame-solicitado-index',
                path: 'index',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-relatorio-quantitativo-exame-solicitado' */
                    '@/views/exame-laboratorial/relatorio-quantitativo-exame-solicitado/List.vue'
                ),
            },
        ],
    }
]